import CopyIcon from '@synapex/frontend-shared/icons/copy-16.svg?react';

import { Toast } from '@/shared/ui';
import { useCopyToClipboard } from '@/shared/hooks';

import classes from './CopyLink.module.scss';

export type CopyLinkProps = {
  link: string;
};
export const CopyLink = ({ link }: CopyLinkProps) => {
  const { copy, hideToast, toastMessage, toastVisible } = useCopyToClipboard();

  const onClick = () => copy(link);

  return (
    <>
      <div onClick={onClick} className={classes.root}>
        <div className={classes.ellipsis}>{link}</div>
        <CopyIcon className={classes.icon} />
      </div>
      <Toast
        message={toastMessage}
        visible={toastVisible}
        onClose={hideToast}
        greenSwooshIcon={true}
      />
    </>
  );
};
